import { FINISH_STARTUP, WS_CONNECTED, WS_DISCONNECTED } from './action-types';

export function finishStartup() {
  return {
    type: FINISH_STARTUP,
  };
}

export function wsConnected() {
  return {
    type: WS_CONNECTED,
  };
}

export function wsDisconnected() {
  return {
    type: WS_DISCONNECTED,
  };
}
